import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Keep a breadcrumb in the browser console for debugging.
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught error:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const message =
      this.state.error?.message ||
      this.state.error?.toString?.() ||
      'Unknown error';

    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
        <div className="max-w-xl w-full bg-white border border-gray-200 rounded-2xl shadow-sm p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-2">Something went wrong</h2>
          <p className="text-sm text-gray-600 mb-4">
            The AI assistant page crashed. The error below should help us fix it.
          </p>
          <pre className="text-sm bg-gray-50 border border-gray-200 rounded-xl p-4 overflow-auto text-gray-800">
            {message}
          </pre>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;

